import React from 'react';
import { Search } from './Search';
import { IOuter } from './Search.types';

export const RtlSearch = (props: IOuter) => (
  <div style={{ direction: 'rtl' }}>
    <Search {...props} />
  </div>
);
